/* OLEEYA wishlist. Browser-local per logged-in customer, guest count stays 0. */
(function(){
 const wrap=()=>document.querySelector('.oleeya-wishlist-wrap');
 const customer=()=>wrap()?.dataset.oleeyaCustomer||'';
 const key=()=>customer()?'oleeya_wishlist_v1_'+customer():null;
 function load(){
  if(!key())return [];
  try{const a=JSON.parse(localStorage.getItem(key())||'[]');return Array.isArray(a)?a.filter(x=>x&&x.id).slice(0,100):[]}catch(e){return []}
 }
 function save(items){try{if(key())localStorage.setItem(key(),JSON.stringify(items.slice(0,100)))}catch(e){}sync()}
 function el(tag,cls,text){const e=document.createElement(tag);if(cls)e.className=cls;if(text!==undefined)e.textContent=text;return e}
 function sync(){
  const items=load(),ids=new Set(items.map(x=>String(x.id)));
  document.querySelectorAll('.oleeya-wishlist-count').forEach(e=>{e.textContent=String(items.length);e.setAttribute('aria-label',items.length+' saved products')});
  document.querySelectorAll('.oleeya-wishlist-count-text').forEach(e=>e.textContent=String(items.length));
  document.querySelectorAll('.oleeya-wishlist-toggle').forEach(e=>{
   const on=ids.has(String(e.dataset.wishlistId));
   e.setAttribute('aria-pressed',String(on));
   e.setAttribute('aria-label',(on?'Remove from wishlist: ':'Add to wishlist: ')+(e.dataset.wishlistTitle||'product'));
  });
 }
 function render(){
  const box=wrap()?.querySelector('.oleeya-wishlist-content');if(!box)return;
  box.replaceChildren();const items=load();
  if(!key()){
   box.appendChild(el('p','oleeya-wishlist-empty','Sign in to save products to your wishlist. Your wishlist count is 0 while signed out.'));
   const login=el('a','oleeya-wishlist-login','Sign in');login.href='/account/login';box.appendChild(login);return;
  }
  if(!items.length){box.appendChild(el('p','oleeya-wishlist-empty','Your wishlist is empty. Browse products and tap the heart to save favorites.'));return}
  items.forEach(p=>{
   const row=el('div','oleeya-wishlist-item');
   if(p.image){const image=el('img');image.src=p.image;image.alt='';image.loading='lazy';row.appendChild(image)}
   const content=el('div');
   const a=el('a',null,p.title);a.href=p.url;content.appendChild(a);
   const remove=el('button','oleeya-wishlist-remove','Remove');remove.type='button';
   remove.addEventListener('click',()=>{save(load().filter(x=>String(x.id)!==String(p.id)));render()});
   content.appendChild(el('div')).appendChild(remove);row.appendChild(content);box.appendChild(row);
  });
 }
 function open(){
  const w=wrap();if(!w)return;
  render();
  w.querySelector('.oleeya-wishlist-overlay').hidden=false;
  w.querySelector('.oleeya-wishlist-header').setAttribute('aria-expanded','true');
  w.querySelector('.oleeya-wishlist-close')?.focus();
 }
 function close(){
  const w=wrap();if(!w)return;
  w.querySelector('.oleeya-wishlist-overlay').hidden=true;
  w.querySelector('.oleeya-wishlist-header').setAttribute('aria-expanded','false');
  w.querySelector('.oleeya-wishlist-header')?.focus();
 }
 document.addEventListener('click',e=>{
  if(e.target.closest('.oleeya-wishlist-header')){e.preventDefault();open();return}
  if(e.target.closest('[data-wishlist-close]')){e.preventDefault();close();return}
  const button=e.target.closest('.oleeya-wishlist-toggle');
  if(!button)return;
  e.preventDefault();e.stopPropagation();
  if(!key()){open();return}
  const id=button.dataset.wishlistId;
  if(!id)return;
  const items=load();const exists=items.some(p=>String(p.id)===String(id));
  if(exists)save(items.filter(p=>String(p.id)!==String(id)));
  else save(items.concat([{id,title:button.dataset.wishlistTitle||'Product',url:button.dataset.wishlistUrl||'#',image:button.dataset.wishlistImage||''}]));
 });
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&wrap()?.querySelector('.oleeya-wishlist-overlay:not([hidden])'))close()});
 document.addEventListener('DOMContentLoaded',sync);
 document.addEventListener('shopify:section:load',sync);
 window.addEventListener('pageshow',sync);
})();
